// KSK用API設定
export const KSK_API_CONFIG = {
  // 既存のAPI（後で削除予定）
  SIGFOX_DATA: process.env.REACT_APP_KSK_SIGFOX_API || 'https://ksk-aircloud.com/api/sigfox/ksk-data/',
  
  // 新しい段階的API
  CUSTOMERS_SERIES: 'https://ksk-aircloud.com/api/sigfox/ksk-customers-series/',
  DEVICES_BY_SERIES: 'https://ksk-aircloud.com/api/sigfox/ksk-devices-by-series',
  DEVICE_HISTORY: 'https://ksk-aircloud.com/api/sigfox/ksk-device-history'
}; 